import React from "react";
import "./Certifications.css";
import { certifications } from "../../portfolio";
import CertificationCard from "../../components/certificationCard/CertificationCard";

function Certifications(props) {
  const theme = props.theme;
  if (
    !certifications.certifications ||
    certifications.certifications.length === 0
  ) {
    return null;
  }
  return (
    <div className="main" id="certs">
      <div className="certs-body-div">
        {certifications.certifications.map((cert) => {
          return (
            <CertificationCard
              certificate={cert}
              theme={theme}
              key={cert.title}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Certifications;
